/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { fonts } from '@/main/theme';

export const ExtFilterPopupStyled = styled.div.attrs({
    'className': 'ext-filter__popup',
    'data-extended-filter': 'extendedFilter',
})`
    padding: 24px 0;
    min-width: 500px;
    min-height: 300px;
    box-sizing: border-box;
    & .select__select-drop-button, & .drop-down-filter__filter-button {
        display: flex;
        align-items: center;
        ${fonts.textMain};
    }

`;
export const ExtFilterHeaderStyled = styled.div.attrs({
    'className': 'ext-filter__header',
    'data-extended-filter-title': 'extendedFilterTitle',
})`
    ${fonts.textHeader3};
    padding: 0 24px;
`;

export const TitleDivStyled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: baseline;
`

export const ExtFilterFooterContainerStyled = styled.div.attrs({
    className: 'ext-filter__footer',
})`
    display: flex;
    width: 100%;
    box-sizing: border-box;
    padding: 24px 24px 0;
`;

export const ExtFilterFooterCloseStyled = styled.div.attrs({
    className:  'ext-filter__close',
})`
    display: flex;
    align-items: center;
    margin-left: 16px;
    cursor: pointer;
`;
